import { Card, CardContent } from "@/components/shadcn/card"
import { LoaderGeneral } from "@/components/common/loaders/LoaderGeneral"

interface Props {
  title: string
  value: React.ReactNode
  /** Small line below the value; may contain an inline control like a select */
  sub?: React.ReactNode
  CustomIcon: React.ElementType
  isLoading?: boolean
  isError?: boolean
}

export function StatisticsCard({ title, value, sub, CustomIcon, isLoading, isError }: Props) {
  return (
    <Card>
      <CardContent className="pt-5 pb-5">
        <div className="flex items-start justify-between gap-3">
          <div className="flex flex-col gap-1">
            <span className="text-sm text-muted-foreground">{title}</span>
            <LoaderGeneral isLoading={isLoading} isError={isError} className="py-4.5">
              <span className="text-3xl font-bold tracking-tight whitespace-nowrap">{value}</span>
              <span className="text-xs text-muted-foreground">{sub}</span>
            </LoaderGeneral>
          </div>
          <div className="p-2.5 rounded-lg bg-primary shrink-0">
            <CustomIcon className="size-5 text-white" />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
